import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, SubAccountCreationDialogueHandler } from './types';
import SubAccountCreationDialogueContext from './AccountCreationContext';

const { ConfirmationDialogue } = vp;

type SubAccountCreationDialogueProps = {
  handleDialogue: DialogueHandler<SubAccountCreationDialogueHandler>;
};

type FC = FunctionComponent<SubAccountCreationDialogueProps>;

const SubAccountCreationDialogue: FC = ({ handleDialogue }: SubAccountCreationDialogueProps) => {
  const { showSubAccountCreationSuccessAlert, showSubAccountCreationErrorAlert, subAccountCreationError } = useContext(
    SubAccountCreationDialogueContext,
  );

  return useMemo(
    () => (
      <div>
        {/* Sub-account Creation Error */}
        <ConfirmationDialogue
          isVisible={showSubAccountCreationErrorAlert}
          title="Error! The sub-account is not created."
          status="error"
          subTitle={`${subAccountCreationError}`}
          confirm={{
            label: 'Back',
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />

        {/*  Sub-account Creation Success */}
        <ConfirmationDialogue
          isVisible={showSubAccountCreationSuccessAlert}
          title="The Sub-Account Is Now Being Processed."
          status="success"
          subTitle="The sub-account is being reviewed and if required, the sub-account will be sent an onboarding application (doesn't apply for certain types of sub-accounts). You can track the status of any sub-accounts through the sub-account listing."
          confirm={{
            label: 'View Sub-Accounts',
            action: () => handleDialogue({ type: 'success', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showSubAccountCreationSuccessAlert, showSubAccountCreationErrorAlert, subAccountCreationError],
  );
};

export default SubAccountCreationDialogue;
